<div class="card">
    <div class="card-body">
        <ejs-grid #notificationGrid [dataSource]='data' gridLines="None" [query]='query'
            (rowSelected)="onRowSelected($event)" [columns]='columns' height="50vh">
            <ng-template #navTemplate let-data>
                <div class="chat-conversation">
                    <div class="conversation-list">
                        <div [ngClass]="{'ctext-wrap': data.IsRead, 'text-wrap': !data.IsRead}">
                            <p>{{ data.Message }}</p>
                            <span class="chat-time mb-0 float-end text-secondary">
                                <i class="bx bx-time-five align-middle me-1"></i>
                                <app-get-date-time
                                    [dateTime]="data.CreatedOn"></app-get-date-time></span>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-grid>
    </div>
</div>